'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _reactHeadroom = require('react-headroom');

var _reactHeadroom2 = _interopRequireDefault(_reactHeadroom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryTable = function (_Component) {
  _inherits(BinaryTable, _Component);

  function BinaryTable(props) {
    _classCallCheck(this, BinaryTable);

    var _this = _possibleConstructorReturn(this, (BinaryTable.__proto__ || Object.getPrototypeOf(BinaryTable)).call(this, props));

    _this.styles = require('./BinaryTable.scss');
    return _this;
  }

  _createClass(BinaryTable, [{
    key: 'onPin',
    value: function onPin() {
      if (document.getElementById('binary_table_headroom') !== null) {
        document.getElementById('binary_table_headroom').style.top = this.props.pinNumb + 'px';
      }
    }
  }, {
    key: 'onUnpin',
    value: function onUnpin() {
      if (document.getElementById('binary_table_headroom') !== null) {
        document.getElementById('binary_table_headroom').style.top = this.props.unPinNumb + 'px';
      }
    }
  }, {
    key: 'onClick',
    value: function onClick(item) {
      if (this.props.onClick) {
        this.props.onClick(item);
      }
    }
  }, {
    key: 'getHeader',
    value: function getHeader() {
      var _this2 = this;

      var _props = this.props,
          gridTitle = _props.gridTitle,
          titles = _props.titles,
          titleStyles = _props.titleStyles;

      var headerClass = this.props.headerClass ? this.props.headerClass : '';
      var grids = gridTitle.split(',');
      var headerData = [];

      titles.forEach(function (title, index) {
        var xsGrid = parseInt(grids[index], 10);
        var mdGrid = parseInt(grids[index], 10);
        if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object' && title.customHeader) {
          var innerHtml = [];
          if (title.children) {
            title.children.forEach(function (child) {
              innerHtml.push(_react2.default.createElement(
                'div',
                { className: _this2.styles.inner_html },
                child.name
              ));
            });
          }
          var style = title.style !== undefined ? title.style : {};
          headerData.push(_react2.default.createElement(
            _Col2.default,
            { style: titleStyles[index], key: Math.random(), xs: xsGrid, md: mdGrid },
            _react2.default.createElement(
              _Row2.default,
              null,
              _react2.default.createElement(
                'div',
                { style: style },
                _react2.default.createElement(
                  'h4',
                  { style: { 'wordBreak': 'break-word' } },
                  title.name
                )
              )
            ),
            title.children && _react2.default.createElement(
              _Row2.default,
              { className: _this2.styles.inner_html_container },
              innerHtml
            )
          ));
        } else {
          headerData.push(_react2.default.createElement(
            _Col2.default,
            { style: titleStyles[index], key: Math.random(), xs: xsGrid, md: mdGrid },
            _react2.default.createElement(
              'h4',
              { style: { 'wordBreak': 'break-word' } },
              title
            )
          ));
        }
      });
      return _react2.default.createElement(
        _Row2.default,
        { className: this.styles.binary_table_title + ' ' + headerClass },
        headerData
      );
    }
  }, {
    key: 'getBody',
    value: function getBody() {
      var _this3 = this;

      var _props2 = this.props,
          onClickData = _props2.onClickData,
          gridTitle = _props2.gridTitle,
          gridRow = _props2.gridRow,
          rows = _props2.rows,
          rowStyles = _props2.rowStyles,
          rowClass = _props2.rowClass;

      var colClass = this.props.colClass ? this.props.colClass : '';
      var grids = gridRow ? gridRow.split(',') : gridTitle.split(',');
      var clickableStyle = this.props.onClick ? { cursor: 'pointer' } : {};
      var bodyData = [];
      rows.forEach(function (row, rowIndex) {
        var rowColumns = [];
        var style = rowStyles.length > 0 ? rowStyles[rowIndex] : {};
        if (row.constructor === Array) {
          row.forEach(function (column, index) {
            var xsGrid = parseInt(grids[index], 10);
            var mdGrid = parseInt(grids[index], 10);
            rowColumns.push(_react2.default.createElement(
              _Col2.default,
              { className: _this3.styles.binary_table_item_col + ' ' + colClass, style: clickableStyle, key: Math.random(), xs: xsGrid, md: mdGrid },
              _react2.default.createElement(
                'h3',
                null,
                column
              )
            ));
          });
        } else {
          rowColumns = row;
        }
        if (onClickData) {
          bodyData.push(_react2.default.createElement(
            _Row2.default,
            { style: style, key: Math.random(), onClick: _this3.onClick.bind(_this3, onClickData[rowIndex]), className: _this3.styles.binary_table_item + ' ' + rowClass },
            rowColumns
          ));
        } else {
          bodyData.push(_react2.default.createElement(
            _Row2.default,
            { style: style, key: Math.random(), className: _this3.styles.binary_table_item + ' ' + rowClass },
            rowColumns
          ));
        }
      });
      return bodyData;
    }
  }, {
    key: 'getNoData',
    value: function getNoData() {
      var check = this.checkData();
      var noDataCustomeMessage = this.props.noDataCustomeMessage;

      if (!check) {
        if (noDataCustomeMessage) {
          return _react2.default.createElement(
            'div',
            { className: this.styles.NoDataAvailableCustom + ' ' + this.styles.binary_table_item },
            _react2.default.createElement(
              'p',
              null,
              noDataCustomeMessage
            )
          );
        }
        return _react2.default.createElement(
          'div',
          { className: this.styles.NoDataAvailable },
          _react2.default.createElement('i', { className: 'fa fa-info-circle' }),
          _react2.default.createElement(
            'h3',
            null,
            'No Results Found'
          ),
          _react2.default.createElement(
            'p',
            null,
            'There are no records to show you right now. there may be no entries or your filters may be too tightly defined.'
          )
        );
      }
    }
  }, {
    key: 'checkData',
    value: function checkData() {
      var rows = this.props.rows;

      var check = true;
      if (rows && rows.length === 0) {
        check = false;
      }
      return check;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          rows = _props3.rows,
          pinStyle = _props3.pinStyle,
          tableStyle = _props3.tableStyle,
          pinBool = _props3.pinBool;

      return _react2.default.createElement(
        _Grid2.default,
        { className: this.styles.binary_table, style: tableStyle },
        pinBool && _react2.default.createElement(
          _reactHeadroom2.default,
          { id: 'binary_table_headroom', style: pinStyle, pinStart: 150, onPin: this.onPin.bind(this), onUnpin: this.onUnpin.bind(this) },
          this.getHeader()
        ),
        !pinBool && this.getHeader(),
        rows && this.getNoData(),
        rows && this.getBody()
      );
    }
  }]);

  return BinaryTable;
}(_react.Component);

BinaryTable.propTypes = {
  gridTitle: _propTypes2.default.string.isRequired, // 1,3,1,1,1,1,3
  titles: _propTypes2.default.array.isRequired,
  titleStyles: _propTypes2.default.array,
  headerClass: _propTypes2.default.string,
  colClass: _propTypes2.default.string,
  rowClass: _propTypes2.default.string,
  pinStyle: _propTypes2.default.object,
  tableStyle: _propTypes2.default.object,
  gridRow: _propTypes2.default.string.isRequired, // 1,3,1,1,1,1,3
  rows: _propTypes2.default.array.isRequired, // [[], [], [... item]]
  rowStyles: _propTypes2.default.array,
  pinBool: _propTypes2.default.bool,
  pinNumb: _propTypes2.default.number,
  unPinNumb: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  onClickData: _propTypes2.default.array,
  noDataCustomeMessage: _propTypes2.default.string
};
BinaryTable.defaultProps = {
  tableStyle: {},
  pinStyle: { 'zIndex': '1098', 'minWidth': '1200px' },
  rowStyles: [],
  titleStyles: [],
  pinBool: false,
  pinNumb: 0,
  unPinNumb: 0
};
exports.default = BinaryTable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryTable/BinaryTable.js
// module id = 2184
// module chunks = 1